export default {
    getUserSubscribers: { method: 'get', url: 'signatures/user-subscribers' },
    postUserSubscribers: { method: 'post', url: 'signatures/user-subscribers' },
    putUserSubscribers: { method: 'put', url: 'signatures/user-subscribers/{id}' },
    deleteUserSubscribers: { method: 'delete', url: 'signatures/user-subscribers/{id}' },
}
